import React, { memo, useEffect, useState } from 'react';

import Modal from '@components/common/Modal';

import { MODAL_WIDTH_580 } from '@constants/modals';

import AttachSchemaConfig from './AttachSchemaConfig';

interface IAttachSchemaModel {
	onClose: () => void;
	isImportOpen: boolean;
	isOranVendor: boolean;
}

const AttachSchemaModel = ({
	onClose,
	isImportOpen,
	isOranVendor,
}: IAttachSchemaModel) => {
	const [isVisibleForm, setIsVisibleForm] = useState(isImportOpen);
	const [isConfirmModalNeeded, setIsConfirmModalNeeded] = useState<boolean>(false);

	useEffect(() => {
		setIsVisibleForm(isImportOpen);
	}, [isImportOpen]);

	return (
		<Modal
			isConfirmDialogNeededOnClose
			isDirtyForm={isConfirmModalNeeded}
			isOpen={isImportOpen}
			onClose={onClose}
			title={isVisibleForm
				? 'Import new Configuration Data Model'
				: 'Upload file'
			}
			width={MODAL_WIDTH_580}
		>
			<AttachSchemaConfig
				isOranVendor={isOranVendor}
				isVisibleForm={isVisibleForm}
				onClose={onClose}
				setIsConfirmModalNeeded={setIsConfirmModalNeeded}
				setIsVisibleForm={setIsVisibleForm}
			/>
		</Modal>
	);
};

export default memo(AttachSchemaModel);
